import BaseTypography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';

const Typography = BaseTypography;

Typography.propTypes = {
  component: PropTypes.elementType,
  variant: PropTypes.oneOf([
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'caption',
    'button',
    'overline',
    'srOnly',
    'inherit',
  ]),
};

export default Typography;
